<template>
    <div>
        <modal-x :show="showPickups" @onclose="showPickups = false">
            <h3 style="text-align:center;font-weight:bold;">{{ lang.contact.selectPickupLocation }}</h3>
            <paged-contact-core :userId="userId" hide-add-new="true" v-on:onselect="onPickupSelected" v-if="showPickups"
                :cat-id="pickupCatId" :apiClient="apiClient"></paged-contact-core>
        </modal-x>
        <modal-x :show="showCities" @onclose="showCities = false" :content-style="{ maxWidth: '800px' }">
            <category-tree :show-node="false" :expand-child="true" :cat-node="cityNode"
                v-on:catSelected="citySelecting"></category-tree>
        </modal-x>
        <modal-x :show="showPhoneDistrict" @onclose="showPhoneDistrict = false" :content-style="{ maxWidth: '800px' }">
            <category-tree :show-node="false" :expand-child="true" :cat-node="phoneDistrictNode"
                v-on:catSelected="phoneDistrictSelecting"></category-tree>
        </modal-x>
        <modal-x :show="showPickupCats" @onclose="showPickupCats = false" :content-style="{ maxWidth: '800px' }">
            <category-tree :show-node="false" :expand-child="true" :cat-node="pickupLocationNode"
                v-on:catSelected="pickupLocationSelecting"></category-tree>
        </modal-x>
        <div>
            <div style="text-align:left;padding:16px" class="row">
                <div class="col-xs-12">
                    <h3>{{ lang.contact.newContact }}</h3>
                </div>
                <input type="hidden" />
                <div class="col-xs-12">
                    <input v-model="newContact.title" type="text" :placeholder="lang.contact.addressRemark"
                        class="form-control" />
                </div>
                <div class="col-xs-12">
                    <input v-model="newContact.name" type="text" :placeholder="lang.contact.contactName"
                        class="form-control" />
                </div>
                <div class="col-xs-12">
                    <div class="input-group">
                        <div class="input-group-btn">
                            <span @click="selectPhoneArea" data-selected="" class="act-phoneAreaNo btn btn-default"
                                style="color: black;">
                                <span class="glyphicon glyphicon-triangle-bottom"></span> {{ phoneArea }}
                            </span>
                        </div>
                        <input v-model="newContact.phone" type="text" class="form-control" :placeholder="lang.common.phone">

                    </div>
                </div>


                <div class="col-xs-12 ags-address-tab-wrapper" v-if="skipAddress !== true">
                    <div style="background:white;padding:4px;">

                        <ul class="nav nav-tabs ags-address-type">
                            <li role="presentation" class="act-tab" :class="{ active: addressTab === 0 }"><a> <span
                                        class="btn btn-default act-tab-custom" @click="addressTab = 0">{{
                                            lang.contact.deliveryAddress
                                        }}</span></a></li>
                            <li role="presentation" class="act-tab"
                                :class="{ active: addressTab === 1, hidden: apiClient.pickupEnabled !== true }"><a><span
                                        class="btn btn-default act-tab-pickup" @click="addressTab = 1">{{
                                            lang.common.pickup
                                        }} </span></a></li>
                        </ul>

                        <div class="ags-tab-address-detail">
                            <div class="tab-content" style="padding:4px;height:160px;">
                                <div class="act-content-tab" :class="{ hidden: addressTab !== 0 }">
                                    <div class="row">
                                        <div class="col-xs-12">
                                            <select v-if="pickupEntry === true" v-on:change="contactTypeChange"
                                                class="form-control" v-model="newContact.contactType">
                                                <option value="">Please select type</option>
                                                <option value="0">Delivery Address</option>
                                                <option value="1">Pick up location</option>
                                            </select>

                                            <span @click="selectCity" data-selected=""
                                                class="act-select-city btn btn-default">
                                                <span class="glyphicon glyphicon-triangle-bottom"></span>{{ city }}
                                            </span>

                                        </div>
                                        <div class="col-xs-12">
                                            <textarea v-model="newContact.address" class='form-control'
                                                :placeholder="lang.contact.newAddress" style="min-height:100px;"></textarea>
                                        </div>

                                    </div>

                                </div>
                                <div class="act-content-tab" :class="{ hidden: addressTab !== 1 }">
                                    <div class="row">
                                        <div class="col-xs-12">
                                            <span @click="selectPickup" class="btn btn-default act-select-pickup"><span
                                                    class="glyphicon glyphicon-triangle-bottom"></span>{{
                                                        lang.common.pickupLocation
                                                    }}</span>
                                        </div>
                                        <div class="col-xs-12">
                                            <div class="form-control" style="min-height:100px;">
                                                <div class="ags-delivery-option" v-if="pickupContact !== null">
                                                    <div>
                                                        <span class="label label-info"> {{ lang.common.pickup }} </span>

                                                        <div class="act-title" style="font-weight:bolder;">
                                                            {{ pickupContact.id }}:{{ pickupContact.title }}
                                                        </div>
                                                    </div>
                                                    <div class="act-detail" style="padding-left:10px;">
                                                        {{ pickupContact.name }}:{{ pickupContact.phone }}
                                                        <div>
                                                            {{ pickupContact.address }}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                <div class="col-xs-12">
                    <div style="text-align:right;margin-top:10px;">
                        <span @click="addContact" class="act-add btn btn-primary">{{ lang.common.add }}</span>
                        <div style="color:red;">
                            {{ msg }}
                        </div>
                    </div>
                </div>

            </div>


        </div>

    </div>
</template>
<script>
import pagedLoading from './base/PagedLoading.vue';
import modalX from './base/ModalX1.vue';
import CategoryTree from './CategoryTree.vue';
import language from '../api/lang';

export default {
    components: {
        CategoryTree: CategoryTree,
        pagedLoading: pagedLoading,
        modalX: modalX,
        pagedContactCore: () => import('./PagedContactCore.vue')
    },
    props: {
        "apiClient": { type: String, default: null },
        "userId": { type: String, default: null },
        "pickupEntry": { type: Boolean, default: false },
        "skipAddress": { type: Boolean, default: false }
    },
    data: function () {
        return {
            items: [],
            paging: { page: 1, pageSize: 1, count: 1 },
            loadingImg: false,
            msg: null,
            phoneArea: language.common.phoneAreaNo,
            city: language.common.city,
            newContact: {
                phoneAreaNo: null,
                cityNo: 0,
                title: null,
                name: null,
                phone: null,
                address: "",
                pickContactId: 0,
                contactType: this.pickupEntry === true ? 1 : 0
            },
            addressTab: 0, //0 for direct address, 1 for pickup
            showPickups: false,
            pickupCatId: null,
            pickupContact: null,
            showCities: false,
            cityNode: null,
            showPhoneDistrict: false,
            phoneDistrictNode: null,
            showPickupCats: false,
            pickupLocationNode: null
        };
    },
    computed: {
        lang: function () {
            return language;
        }
    },
    methods: {
        resetCity() {
            this.city = language.common.city;
            this.newContact.cityNo = 0
        },
        contactTypeChange() {
            this.resetCity();
        },
        pickupLocationSelecting(ret) {
            this.pickupCatId = ret.child.catId;
            this.showPickupCats = false;
            this.showPickups = true;
        },
        onPickupSelected: function (pickupContact) {
            this.pickupContact = pickupContact;
            this.newContact.pickContactId = pickupContact.id;
            this.showPickups = false;
        },
        selectPickup: function () {
            this.apiClient.getPickupPrms(this.userId).done((ret) => {
                this.pickupLocationNode = ret;
                this.showPickupCats = true;
            });
        },
        selectPhoneArea: function () {
            this.apiClient.getPhoneDistrictPrms().done((ret) => {
                this.showPhoneDistrict = true;
                this.phoneDistrictNode = ret;
            });
        },
        phoneDistrictSelecting(ret) {
            this.phoneArea = ret.parent.name + "/" + ret.child.name;
            this.newContact.phoneAreaNo = ret.child.catId;
            this.showPhoneDistrict = false;
        },
        selectCity: function () {
            if (this.newContact.contactType == 0) {
                this.apiClient.getCityPrms().done((ret) => {
                    this.showCities = true;
                    this.cityNode = ret;
                });
            } else {
                this.apiClient.getPickupPrms(this.userId).done((ret) => {
                    this.showCities = true;
                    this.cityNode = ret;
                });
            }
        },
        citySelecting(ret) {
            console.log('city selecting', ret);
            this.city = ret.parent.name + "/" + ret.child.name;
            this.newContact.cityNo = ret.child.catId;
            this.showCities = false;
        },
        addContact: function () {
            this.msg = "";

            this.newContact.contactType = this.addressTab;
            //validate data
            console.log("new contact:", this.newContact);

            var hasTitle = this.newContact.title !== null;
            var hasName = this.newContact.name !== null;
            var hasPhone = this.newContact.phone !== null;
            var hasPhoneArea = this.newContact.phoneAreaNo !== null;

            if (!(hasName && hasPhone && hasPhoneArea && hasTitle)) {
                this.msg = this.lang.contact.wrongContactValue;
                return;
            }

            if (this.skipAddress !== true) {
                var contactType = this.newContact.contactType;
                if (contactType === 0) {
                    //direct user address
                    var addressNotEmpty = this.newContact.address !== null;
                    var hasCity = this.newContact.cityNo !== 0;

                    var isValid = addressNotEmpty && hasCity;
                    if (!isValid) {
                        this.msg = this.lang.contact.wrongAddressValue;
                        return;
                    }

                } else {
                    //pickup
                    var hasPickup = this.newContact.pickContactId !== 0;
                    if (!hasPickup) {
                        this.msg = this.lang.contact.wrongPickupValue;
                        return;
                    }
                }
            }
            //end validation

            this.apiClient.addContactPrms(this.newContact)
                .done((ret) => {
                    this.$emit('oncreate', ret);
                });
        }
    }
    ,
    created: function () {
        //this.loadItems();
        //this.apiClient.onLoginApi.on(this.loadItems);
    },
    //destroyed: function () {
    //    this.apiClient.onLoginApi.remove(this.loadItems);
    //}
}
</script>